import axios from "@/api/axiosInstance";
import { DeleteCatalogProductResponse } from "./types";

export const deleteCatalogProduct = async (
  id: string,
): Promise<DeleteCatalogProductResponse> => {
  const response = await axios.delete<DeleteCatalogProductResponse>(
    `/api/private/product-catalog/products/${id}`,
  );
  return response.data;
};
